module.exports = __webpack_public_path__ + "static/media/Alex_logo2.40603b4a.png";